import React from "react";

import { selectFeatureResourceMetricsThresholdEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import Threshold from "./Thresholds";
import VerticalAxis from "./VerticalAxis";

const Thresholds = props => {
  const enableThreshold = useAppSelector(
    selectFeatureResourceMetricsThresholdEnabled
  );

  return enableThreshold ? (
    <Threshold {...props} />
  ) : (
    <VerticalAxis {...props} />
  );
};

export default React.memo(Thresholds);
